import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=1b5d281a&"
import script from "./VisitDetail.vue?vue&type=script&lang=js&"
export * from "./VisitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports